import { matchPath } from "react-router-dom";
import Layout from "../pages/Layout";
import Brands from "../pages/Brands";
import Live from "../pages/Live";
import Login from "../pages/Login";
import PinLogin from "../pages/PinLogin";
import PinSignup from "../pages/PinSignup";
import Search from "../pages/Search";
import DetailPage from "../pages/DetailPage";
import FullCatalog from "../pages/FullCatalog";
import MyLibrary from "../pages/MyLibrary";
import Splash from "../pages/Splash";
import Settings from "../pages/Settings";
import ParentalControl from "../pages/ParentalControl";
import AgeRestriction from "../pages/AgeRestriction";
import EpisodesSelectorPage from "../pages/EpisodesSelectorPage";
import Signup from "../pages/Signup";
import VoucherRedemption from "../pages/VoucherRedemption";
import ThankYou from "../pages/ThankYou";
import Promotions from "../pages/Promotions";
import Landing from "../pages/Landing";
import NonChangeable from "../pages/NonChangeable";
import Welcome from "../pages/Welcome";
import BuyAsset from "../pages/BuyAsset";
import BuyBrands from "../pages/BuyBrands";
import LivePage from "../pages/LivePage";
import EditProfile from "../pages/EditProfile";
import AddProfile from "../pages/AddProfile";
import ProfileName from "../pages/ProfileName";
import AccountPassword from "../pages/AccountPassword";
import LoginOrSignup from "../pages/LoginOrSignup";
import PinLock from "../pages/PinLock";
import ProfileSelector from "../pages/ProfileSelector";
import DeletedProfile from "../pages/DeletedProfile";
import CategoriesMenuPage from "../pages/CategoriesMenuPage";
import ExitAppPage from "../pages/ExitAppPage";

export const sections = {
  HOME: "home",
  SPORTS: "sports",
  SERIES: "series",
  MOVIES: "movies",
  ARABIC: "arabic",
  KIDS: "kids",
  DISCOVERY: "discovery",
  UFC: "ufc",
  BLUTV: "blutv",
  PREMIERSPORTS: "premiersports",
  ADSPORTS: "adsports",
  CRICLIFE: "criclife",
  MAJIDTV: "majidtv",
  GOLFTV: "golftv",
  FIFA: "fifa",
  BRANDS: "brands",
  BRANDS1: "brands1",
  LIVE: "live",
  MYLIBARAY: "mylist",
  BRANDS_NAME: "brands_name",
  SEARCH: "search",
  BUYASSET: "buyasset",
  BUYBRANDS: "buyBrands",
  STORE: "store",
  FREETV: "freemium",
  WCT2026: "wct2026",
  ADMN: "admn"
};

export const routes = {
  splash: "/",
  login: "/login",
  pin: "/pin",
  pinSignup: "/pin-signup",
  search: `/${sections.SEARCH}`,
  home: `/${sections.HOME}`,
  sports: `/${sections.SPORTS}`,
  series: `/${sections.SERIES}`,
  store: `/${sections.STORE}`,
  movies: `/${sections.MOVIES}`,
  arabic: `/${sections.ARABIC}`,
  kids: `/${sections.KIDS}`,
  freeTV: `/${sections.FREETV}`,
  wct2026: `/${sections.WCT2026}`,
  [sections.LIVE]: `/${sections.LIVE}`,
  brands1: `/${sections.BRANDS1}`,
  [sections.BRANDS]: `/${sections.BRANDS}`,
  [sections.BRANDS_NAME]: `/${sections.BRANDS}/:name`,
  explore: "/explore",
  mylibrary: "/mylibrary",
  settings: "/settings",
  parentalControl: "/parentalControl",
  AgeRestriction: "/age-restriction",
  exit: "/exit",
  signup: "/signup",
  redeem: "/redeem",
  promotions: "/promotions",
  thankyou: "/thankyou",
  landing: "/landing",
  nonchangeable: "/nonchangeable",
  welcome: "/welcome",
  player: "/player",
  buyasset: "/buyasset",
  buyBrands: "/buybrands",
  editProfile: "/edit-profile",
  addProfile: "/add-profile",
  profileName: "/profile-name",
  accountPassword: "/account-password",
  pinLock: "/pin-lock",
  profileSelector: "/profile-selector",
  deletedProfile: "/deleted-profile",
  loginOrSignup: "/loginOrSignup",
  categoriesMenuPage: "/categoriesMenuPage",
  exitAppPage: "/exitAppPage",
  admn: `/${sections.ADMN}`,
  category: "/category"
};

// FIXME: make routes for the discovery dynamic like other pages

const pages = [
  {
    route: routes.splash,
    name: "Splash",
    component: Splash,
    kidsAllowed: true,
    isRoot: true
  },
  {
    route: routes.settings,
    name: "Settings",
    component: Settings,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.login,
    name: "Login",
    component: Login,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.pin,
    name: "Pin",
    component: PinLogin,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.pinSignup,
    name: "PinSignup",
    component: PinSignup,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.search,
    name: "Search",
    component: Search,
    subtheme: false,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.home,
    name: "Home",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: routes.store,
    name: "Store",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: routes.sports,
    name: "Sports",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },

  {
    route: routes.freeTV,
    name: "FreeTV",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: routes.wct2026,
    name: "wct2026",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: `${routes.series}/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.series,
    name: "Series",
    component: Layout,
    isRoot: true
  },
  {
    route: `${routes.series}/:titleId/episodes`,
    name: "Episodes Selector",
    component: EpisodesSelectorPage,
    isRoot: false
  },
  {
    route: `${routes.kids}${routes.series}/:titleId/episodes`,
    name: "Episodes Selector",
    component: EpisodesSelectorPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: `${routes.explore}${routes.series}`,
    name: "Series Full Catalog",
    component: FullCatalog,
    subtheme: true,
    isRoot: false
  },
  {
    route: `${routes.explore}${routes.sports}`,
    name: "Sports Full Catalog",
    component: FullCatalog,
    subtheme: true,
    isRoot: false
  },
  {
    route: `${routes.explore}${routes.wct2026}`,
    name: "WCT 2026",
    component: FullCatalog,
    subtheme: true,
    isRoot: false
  },
  {
    route: `${routes.explore}${routes.store}`,
    name: "Store Full Catalog",
    component: FullCatalog,
    subtheme: true,
    isRoot: false
  },
  {
    route: `${routes.explore}${routes.freeTV}`,
    name: "FreeTV Full Catalog",
    component: FullCatalog,
    subtheme: true,
    isRoot: false
  },
  {
    route: `${routes.movies}/:titleName/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.movies}/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.movies,
    name: "Movies",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: `${routes.explore}${routes.movies}`,
    name: "Movies Full Catalog",
    component: FullCatalog,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.arabic}${routes.series}/:titleId/episodes`,
    name: "Episodes Selector",
    component: EpisodesSelectorPage,
    isRoot: false
  },
  {
    route: `${routes.arabic}${routes.movies}/:titleName/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.admn}${routes.series}/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: `${routes.arabic}${routes.movies}/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.arabic}${routes.series}/:titleName/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.arabic}${routes.series}/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.arabic,
    name: "Arabic",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: `${routes.explore}${routes.arabic}`,
    name: "Arabic Full Catalog",
    component: FullCatalog,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.kids}${routes.movies}/:titleName/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: `${routes.kids}${routes.movies}/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: `${routes.kids}${routes.series}/:titleName/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: `${routes.admn}${routes.movies}/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    subtheme: true,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes.category}/:name`,
    name: "Sub Category",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: `${routes.admn}/:name`,
    name: "ADMN Sub Category",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: routes.admn,
    name: "Abu Dhabi Media Network",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: `${routes.kids}${routes.series}/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.kids,
    name: "Kids",
    component: Layout,
    subtheme: "kids",
    kidsAllowed: true,
    isRoot: true
  },
  {
    route: `${routes.explore}${routes.kids}`,
    name: "Kids Full Catalog",
    component: FullCatalog,
    subtheme: true,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.mylibrary,
    name: "My Library",
    component: MyLibrary,
    subtheme: false,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.parentalControl,
    name: "Parental Control",
    component: ParentalControl,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.AgeRestriction,
    name: "Age Restriction",
    component: AgeRestriction,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.exit,
    name: "Exit",
    component: Layout,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.signup,
    name: "Signup",
    component: Signup,
    kidsAllowed: true,
    isRoot: true
  },
  {
    route: routes.redeem,
    name: "VoucherRedemption",
    component: VoucherRedemption,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.thankyou,
    name: "ThankYouPage",
    component: ThankYou,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.landing,
    name: "LandingPage",
    component: Landing,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.welcome,
    name: "WelcomePage",
    component: Welcome,
    kidsAllowed: true,
    isRoot: true
  },
  {
    route: routes[sections.BRANDS_NAME],
    name: "brand name",
    component: Layout,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: routes.promotions,
    name: "promotionsPage",
    component: Promotions,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.nonchangeable,
    name: "NonChangeable",
    component: NonChangeable,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: `${routes.explore}${routes[sections.BRANDS_NAME]}`,
    name: ` Full Catalog`,
    component: FullCatalog,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes[sections.BRANDS_NAME]}${routes.series}/:titleId/episodes`,
    name: "Episodes Selector",
    component: EpisodesSelectorPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes[sections.BRANDS_NAME]}${routes.movies}/:titleName/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes[sections.BRANDS_NAME]}${routes.movies}/:titleId`,
    name: "DetailMovie",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes[sections.BRANDS_NAME]}${routes.series}/:titleName/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: `${routes[sections.BRANDS_NAME]}${routes.series}/:titleId`,
    name: "DetailSeries",
    component: DetailPage,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.brands1,
    name: "Brands1",
    component: Brands,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: routes.brands,
    name: "Brands",
    component: Brands,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: routes.live,
    name: "Live",
    component: LivePage,
    kidsAllowed: false,
    isRoot: true
  },
  {
    route: routes.buyasset,
    name: "BuyAsset",
    component: BuyAsset,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.buyBrands,
    name: "BuyBrands",
    component: BuyBrands,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.editProfile,
    name: "EditProfile",
    component: EditProfile,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.addProfile,
    name: "AddProfile",
    component: AddProfile,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.profileName,
    name: "ProfileName",
    component: ProfileName,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.accountPassword,
    name: "AccountPassword",
    component: AccountPassword,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.pinLock,
    name: "PinLock",
    component: PinLock,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.profileSelector,
    name: "ProfileSelector",
    component: ProfileSelector,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.deletedProfile,
    name: "deletedProfile",
    component: DeletedProfile,
    kidsAllowed: false,
    isRoot: false
  },
  {
    route: routes.loginOrSignup,
    name: "LoginOrSignup",
    component: LoginOrSignup,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.categoriesMenuPage,
    name: "CategoriesMenuPage",
    component: CategoriesMenuPage,
    kidsAllowed: true,
    isRoot: false
  },
  {
    route: routes.exitAppPage,
    name: "ExitAppPage",
    component: ExitAppPage,
    kidsAllowed: true,
    isRoot: false
  }
];

const cache = new Map();

export const getRouteByPath = path => {
  if (!cache.has(path)) {
    cache.set(
      path,
      pages.find(page =>
        matchPath(path, {
          path: page.route,
          exact: true,
          strict: false
        })
      )
    );
  }
  return cache.get(path);
};

export const isRootPath = path => (path.match(/\//g) || []).length === 1;

export default { pages };
